"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-demetrio-corone": {
    "f2e8b019": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "skipSearch": false
    }],
    "cacossa": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4a3a908": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "skipSearch": false
    }],
    "foreste": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e718f915": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "skipSearch": false
    }],
    "piedigallo": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6b6aba60": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "skipSearch": false
    }],
    "poggio": [{
      "hkey": "86020fd5",
      "slug": "san-demetrio-corone",
      "name": "San Demetrio Corone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;